import { lazyGetChannelReady } from 'owa-notification';

export default function runAfterNotificationSetup(operation: () => void) {
    lazyGetChannelReady.import().then(getChannelReady => {
        getChannelReady().then(operation);
    });
}
